var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('p',[_vm._v("Une fois chargé, vous pourrez lire le fichier PDF.")]),_c('p',[_vm._v("En cas de problème, cliquez sur le lien : "),_c('a',{attrs:{"href":_vm.linkToPDF}},[_vm._v(_vm._s(_vm.linkToPDF))])])])}
var staticRenderFns = []

export { render, staticRenderFns }